<template>
  <div>
    <md-card class="search-area">
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>search</md-icon>
              검색 조건
        </h4>
      </md-card-header>

      <md-card-content>
          <table class="flex-table">
          <tr>
              <th>임원직위</th>
              <td>
              <select v-focus v-model="query.levelCd">
                  <option value="">직위 선택</option>
                  <option v-for="item in orgLevelList" :key="item.code" :label="item.codeNm" :value="item.code">
                  </option>
              </select>
              </td>
              <th>現 임원단 여부</th>
              <td>
                <label>
                  <input type="radio" v-model="query.alumniGb" value="Y" name="alumniGb" />Y
                </label>
                <label>
                  <input type="radio" v-model="query.alumniGb"  value="N" name="alumniGb" />N
                </label>
<!--                <label>-->
<!--                  <input type="radio" v-model="query.alumniGb" value="" name="alumniGb" />전체-->
<!--                </label>-->
              </td>
              <th>대수</th>
              <td><input type="text" maxlength="3" v-model="query.reign" v-on:keyup.enter="searchQuery"></td>
              <th>교우명</th>
              <td><input type="text" v-model="query.memberHnm" v-on:keyup.enter="searchQuery"></td>
              <th>취임일</th>
              <td>
              <div class="inline-flex">
                <input type="text" v-model="query.erectDate" v-mask="'####-##-##'" v-on:keyup.enter="searchQuery">
              </div>
              </td>
              <th>퇴임일</th>
              <td>
              <div class="inline-flex">
                <input type="text" v-model="query.expireDate" v-mask="'####-##-##'" v-on:keyup.enter="searchQuery">
              </div>
              </td>
          </tr>
          <tr>
              <th>직종명</th>
              <td>
              <div class="inline-flex">
                  <input type="text" disabled v-model="searchedWorkName1" />
                  <button @click=" () => { this.isShowWorkModal1 = true; }">
                    <md-icon>search</md-icon>
                  </button>
                  <input type="text" disabled v-model="searchedWorkName2" />
                  <button @click="() => { this.isShowWorkModal2 = true; }">
                    <md-icon>search</md-icon>
                  </button>
              </div>
              </td>
              <th>직장명</th>
              <td>
				        <div class="inline-flex">
                  <input type="text" v-model="searchedCompanyName" />
                  <button @click="checkCompanyPop">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th>부서</th>
              <td>
              <input type="text" v-model="query.partNm" v-on:keyup.enter="searchQuery">
              </td>
              <th>교우번호</th>
              <td><input type="text" v-model="query.memberNo" v-on:keyup.enter="searchQuery"></td>
              <th>직위</th>
              <td>
              <input type="text" v-model="query.levelNm" v-on:keyup.enter="searchQuery">
              </td>
              <th>직책</th>
              <td>
              <input type="text" v-model="query.positionNm" v-on:keyup.enter="searchQuery">
              </td>
          </tr>
          <tr>
              <th>추천여부</th>
              <td colspan="5">
              <label>
                <input type="radio" value="ALL" v-model="query.memberjbGb">추천전체
              </label>
              <label>
                  <input type="radio" value="JB" v-model="query.memberjbGb">대학
              </label>
              <label>
                  <input type="radio" value="JN" v-model="query.memberjbGb">지부
              </label>
              <label>
                  <input type="radio" value="NB" v-model="query.memberjbGb">분회
              </label>
              <label>
                  <input type="radio" value="NN" v-model="query.memberjbGb">추천없음
              </label>
              </td>
              <th>학번</th>
              <td><input type="text" v-model="query.hakbun" v-on:keyup.enter="searchQuery"></td>
              <!--<th>학사구분</th>
              <td>
              <input type="text" list="datalist002">
              <datalist id="datalist002">
                  <option>선택하세요</option>
                  <option>선택2</option>
              </datalist>
              </td>-->
              <th>대학명</th>
              <td>
              <div class="inline-flex">
                  <input type="text" disabled v-model="searchedCollegeName">
                  <button @click="() => { this.isShowCollegeModal = true }"><md-icon>search</md-icon></button>
              </div>
              </td>
              <th>학과명</th>
              <td>
              <div class="inline-flex">
                  <input type="text" disabled v-model="searchedClassName"/>
                  <button @click=" () => { this.isShowClassModal = true; }"><md-icon>search</md-icon></button>
              </div>
              </td>
          </tr>
          <tr>
              <th>분담금</th>
              <td colspan="5">
              <div class="inline-flex">
                  <input type="text" class="w80" placeholder="회비년도" maxlength="4" v-mask="'####'" v-model="query.lastFeeYear">
                  <label><input type="radio" v-model="query.feeSuccess" value="Y" name="feeSuccess">납부자</label>
                  <label><input type="radio" v-model="query.feeSuccess" value="N" name="feeSuccess">미납자</label>
              </div>
              </td>
              <th>학위</th>
              <td>
                <select v-model="query.degreeCd" name="degreeCd">
                  <option value="">- 선택 -</option>
                  <option v-for="item in degreeCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                    {{ item.codeNm }}
                  </option>
                </select>
              </td>
              <th>입학년월</th>
              <td>
              <div class="inline-flex">
                <input type="text" v-model="query.enterYm" v-mask="'####-##'" v-on:keyup.enter="searchQuery">
              </div>
              </td>
              <th>졸업년월</th>
              <td>
              <div class="inline-flex">
                <input type="text" v-model="query.graduationYm" v-mask="'####-##'" v-on:keyup.enter="searchQuery">
              </div>
              </td>
          </tr>
          </table>
      </md-card-content>
      <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="searchQuery">
          <md-icon>search</md-icon>검 색
          </md-button>
          <md-button class="md-default md-sm" @click="clearQuery">
          <md-icon>clear</md-icon>초기화
          </md-button>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>assignment</md-icon>검색 결과
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          
          <div>
            <select v-model="pagination.perPage" name="pages" @change="perPageChange">
              <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                {{ item }}
              </option>
            </select>
          </div>

        </div>

        <grid ref="executivesSearchGrid"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @dblclick="onDbClickExecutive"
            @response="response"
        ></grid>
        
      </md-card-content>
      <slot name="bottomRightArea"></slot>
    </md-card>

    <!-- --------------------------- Modal Popup --------------------------------------->
    <div>
      <!--직종선택 팝업 -->
      <work-search-pop-comp1 :is-show.sync="isShowWorkModal1" @returnResult="callbackWork1"></work-search-pop-comp1>
      <work-search-pop-comp2 :is-show.sync="isShowWorkModal2" :l-code-cd.sync="query.workCd1" @returnResult="callbackWork2"></work-search-pop-comp2>

      <!--직장선택 팝업 -->
      <company-search-pop-comp :is-show.sync="isShowCompanyModal" :search-text.sync="searchedCompanyName" :l-code-cd.sync="query.workCd1" :m-code-cd.sync="query.workCd2" @returnResult="callbackCompany"></company-search-pop-comp>

      <!--대학선택 팝업 -->
      <college-search-pop-comp :is-show.sync="isShowCollegeModal" @returnResult="callbackCollege"></college-search-pop-comp>

      <!--학과선택 팝업 -->
      <class-search-pop-comp :is-show.sync="isShowClassModal" :l-code-cd.sync="collegeLCodeCd" :m-code-cd.sync="query.collegeCd" @returnResult="callbackClass"></class-search-pop-comp>

    </div>
    <!-- --------------------------- Modal Popup --------------------------------------->
  </div>
</template>
<script>

import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';


import moment from "moment";

import { WorkSearchPopComp1, WorkSearchPopComp2, CompanySearchPopComp, CollegeSearchPopComp, ClassSearchPopComp } from "@/pages"

export default {
  name: "ExcutiveSearchComp",
  props: {
    levelList: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  components: {
    grid: Grid,
    WorkSearchPopComp1,
    WorkSearchPopComp2,
    CompanySearchPopComp,
    CollegeSearchPopComp,
    ClassSearchPopComp
  },

  created() {
    this.getDegreeCdList();
    this.initGrid();
  },

  computed: {
      orgLevelList: function() {
          return this.levelList;
      },
      total: function() {
        return this.pagination.total
      }
  },
  data() {
    return {
        kuaaFnc,
        formatter,

        pagination: {
          page: 1,
          perPage: 20,
          perPageOptions: [20, 50, 100, 200, 500],
          total: 0
        },

		// 직종 검색
		searchedWorkName1: "",
		isShowWorkModal1: false,
		
		searchedWorkName2: "",
		isShowWorkModal2: false,
		
		// 직장명 검색
		searchedCompanyName: "",
		isShowCompanyModal: false,

        // 대학 선택 데이터
        isShowCollegeModal: false,
        searchedCollegeName: "",

        // 학과 선택 데이터
        isShowClassModal: false,
        searchedClassName: "",

        degreeCdList : [],

        tableData: [],
        searchedData: [],
        fuseSearch: null,
        query: {
            levelCd: "",    //임원진 직위코드
            alumniGb: '',       // 현 임원진 여부 field 추가
            reign: null,          // '대수' field 추가
            erectDate: null,      // 취임일 field 추가
            expireDate: null,     // 퇴임일 field 추가
	        companyNm: "",
	        companyId: "", // 직종 공통코드 검색 후 assign
            partNm: "",         // 부서
            levelNm: "",        // 직위
            positionNm: "",     // 직책
            branchId: "",       // 추천 여부. 대학/지부/분회/추천없음  -  JN : 지부, NB : 분회, JB : 지부/분회, NN : ??
            collegeCd: "",      // 대학/학과명 연동 코드
            // 학사구분 제거해야 할 것으로 예상
            enterYm: null,        //입학년도
            graduationYm: null,   //졸업년도
            lastFeeYear: "",     //회비년도
            feeSuccess : null,
            memberjbGb : null,
            memberHnm : null,
            memberNo : null,
            hakbun : null,
            degreeCd : "",
            workCd1: "",
            workCd2: ""
        },
        executiveList: [],
        workLCodeCd: "",        // 팝업에서 선택한 직종의 대분류코드
        collegeLCodeCd: "",     // 팝업에서 선택한 대학의 대분류코드
        orgGbItems: []
    };
  },
  methods: {
    /**
     * 검색 실행
     */
    searchQuery() {
      this.doSearch();
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.executivesSearchGrid, event, this.pagination);
    },

    doSearch() {
      let tmpCompanyNm = this.query.companyNm == true? this.query.companyNm : this.searchedCompanyName.trim();
      let tmpWorkCd1   = this.query.workCd1;
      let tmpWorkCd2   = this.query.workCd2;
      
      // 직장명이 있는 경우
      if(!this.query.companyId.trim() == '' || !this.searchedCompanyName.trim() == ''){
        if(!this.query.companyId.trim() == '')  this.query.companyNm = '';
        else                                    this.query.companyNm = tmpCompanyNm;
        this.query.workCd1 = '';
        this.query.workCd2 = '';
      };
      
      if(this.query.feeSuccess){
        if(!this.query.lastFeeYear){
          kuaaFnc.showSwal("분담금", "회비년도를 입력하셔야 합니다.");
          return false;
        }
      }

      if(this.query.lastFeeYear){
        if(!this.query.feeSuccess){
          kuaaFnc.showSwal("분담금", "납부자/미납자 선택을 해주세요.");
          return false;
        }
      }
      
      let params = JSON.parse(JSON.stringify(this.query));
      //params.erectDate = this.customFormatter(params.erectDate);
      //params.expireDate = this.customFormatter(params.expireDate);
      //params.enterYm = this.customFormatter2(params.enterYm);
      //params.graduationYm = this.customFormatter2(params.graduationYm);
      
      this.$refs.executivesSearchGrid.invoke("readData", 1, params);
      
      this.query.companyNm = tmpCompanyNm;
      this.query.workCd1 = tmpWorkCd1;
      this.query.workCd2 = tmpWorkCd2;
    },

    /**
     * 검색 조건 초기화
     */
    clearQuery() {
      this.query = {
        levelCd: "",    //임원진 직위코드
        alumniGb: '',       // 현 임원진 여부 field 추가
        reign: null,          // '대수' field 추가
        erectDate: null,      // 취임일 field 추가
        expireDate: null,     // 퇴임일 field 추가
        companyNm: "",      // 직종코드, 직장명 연동 코드
        companyId: "",      // 직장코드
        partNm: "",         // 부서
        levelNm: "",        // 직위
        positionNm: "",     // 직책
        branchId: "",       // 추천 여부. 대학/지부/분회/추천없음  -  JN : 지부, NB : 분회, JB : 지부/분회, NN : ??
        collegeCd: "",      // 대학/학과명 연동 코드
        classCd: "",      // 대학/학과명 연동 코드
        // 학사구분 제거해야 할 것으로 예상
        enterYm: null,        //입학년도
        graduationYm: null,   //졸업년도
        lastFeeYear: "",     //회비년도
        feeSuccess : null,
        memberjbGb : null,
        memberHnm : null,
        memberNo : null,
        hakbun : null,
        degreeCd : null,
        workCd1: "",
        workCd2: ""
      };
      this.searchedCollegeName = "";
      this.searchedClassName = "";
      this.searchedCompanyName = "";
      this.searchedWorkName1 = "";
      this.searchedWorkName2 = "";
    },

    /**
     * 직종 검색
     */
    callbackWork1(result) {
      if(result && result.code){
        if(this.query.workCd1 != result.code && this.query.workCd2){
          this.searchedWorkName2 = "";
          this.query.workCd2 = "";
        }
        this.searchedWorkName1 = result.codeNm;
        this.query.workCd1 = result.code;
      }
    },
    callbackWork2(result) {
      if(result && result.code){
        this.searchedWorkName2 = result.codeNm;
        this.query.workCd2 = result.code;
        this.query.workCd1 = result.lCodeCd;
        this.searchedWorkName1 = result.lCodeNm;
      }
    },

    /**
     * 직장명 검색
     */
    callbackCompany(result) {
      if(result && result.code){
        this.searchedWorkName2 = result.mCodeNm;
        this.query.workCd2 = result.mCodeCd;
        this.query.workCd1 = result.lCodeCd;
        this.searchedWorkName1 = result.lCodeNm;
        this.searchedCompanyName = result.codeNm;
        this.query.companyNm = result.codeNm;
        //this.query.companyId = result.code;
      }
    },

    checkCompanyPop(){
      if(this.query.workCd1 || this.query.workCd2){
        kuaaFnc.showSwal("직장 선택", "직종과 함께 검색할 수 없습니다<br>검색조건 초기화 후에 다시 선택해 주세요");
        return false;
      }
      this.isShowCompanyModal = true;
    },

    /**
     * 대학 검색
     */
    callbackCollege(result) {
      this.searchedCollegeName = result.codeNm;
      this.query.collegeCd = result.code;
      this.collegeLCodeCd = result.lCodeCd;
      this.searchedClassName = "";
    },

    /**
     * 학과 검색
     */
    callbackClass(result) {
      this.searchedClassName = result.codeNm;
      this.query.classCd = result.code;
      this.searchedCollegeName = result.mCodeNm;
      this.query.collegeCd = result.mCodeCd;
    },

    getDegreeCdList() {
      kuaaFnc.fncDegreeCdList(null,res => {
        this.degreeCdList = res.data.data.contents;
      });
    },

    checkClassPop(){
      if(this.query.collegeCd){
        this.isShowClassModal = true;
      }else{
        kuaaFnc.showSwal("학과 선택", '대학을 먼저 선택하세요');
      }
    },
    
    
    checkWorkCd2Pop(){
      if(this.query.workCd1){
        this.isShowWorkModal2 = true;
      }else{
        kuaaFnc.showSwal("직종 소분류 선택", '직종 대분류를 선택하세요');
        return false;
      }
    },
    
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_ORG_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesSearchGrid;
      this.gridProps['columns']= [
        {header: '교우번호', name: 'memberNo', width:70, align:"center", sortable: true,
          formatter(value) {
            return `<span style="color:#0091d5; text-decoration:underline; cursor:pointer">${value.value}</span>`;
          }
        },
        {header: '교우명', name: 'memberHnm', width:100, sortable: true},
        {header: '교우직위', name: 'levelCdNm', align:"center", width:80, sortable: true,
          formatter(value) {
            return `<span style="color:#0091d5; cursor:pointer">${value.value}</span>`;
          }
        },
        {header: '성별', name: 'sex', align:"center", sortable: true},
        {header: '생년월일', name: 'birthday', align:"center", width:80, sortable: true,
          formatter(value) {
            return (value.value && value.value.length == 8) ? formatter.getDateFormat(value.value) : value.value;
          }
        },
        {header: '대학명', name: 'collegeCdNm', width:90, align:"center", sortable: true},
        {header: '학과명', name: 'classCdNm', width:120, sortable: true},
        {header: '학번', name: 'hakbun', width:70, align:"center", sortable: true},
        {header: '졸업회수', name: 'graduationNo', align:"center", width:70, sortable: true},
        {header: '졸업년월', name: 'graduationYm', align:"center", width:70, sortable: true,
          formatter(value) {
            return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
          }
        },
        {header: '입학년월', name: 'enterYm', align:"center", width:70, sortable: true,
          formatter(value) {
            return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
          }
        },
        {header: '학위', name: 'degreeNm', width:80, align:"center", sortable: true},
        {header: '대수', name: 'reign', align:"center", sortable: true,
          //formatter(value) {
          //  return (value.value)? `<span style="color:#0091d5; text-decoration:underline; cursor:pointer">${value.value}</span>` : ``;
          //}
        },
        {header: '직장명', name: 'companyNm', width:150, sortable: true},
        {header: '부서', name: 'partNm', width:100, sortable: true},
        {header: '직책', name: 'levelNm', width:100, align:"center", sortable: true},
        {header: '추천여부', name: 'memberjbGbNm', width:70, align:"center", sortable: true},
        {header: '평생회비납부', name: 'memberGb', width:120, align:"center", sortable: true},
        {header: '최종납입년도', name: 'lastFeeYear', width:100, align:"center", sortable: true},
        {header: '납부년월일', name: 'lastFeeDate', width:100, align:"center", sortable: true},
        {header: '취임일', name: 'erectDate', align:"center", width:80, sortable: true},
        {header: '퇴임일', name: 'expireDate', align:"center", width:80, sortable: true}
      ];
      this.gridProps['columnOptions'].frozenCount = 3;
      this.gridProps['theme'].name = 'default';
      this.gridProps['theme'].value.row = null;
    },

    response(e){
      let _this = this;
      
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
        let array = [];
        for(let i = 0; i<this.gridProps['columns'].length; i++){
        	array[i] = this.gridProps['columns'][i];
        }
        this.$emit('returnColumns', array);
        this.$emit('returnPagingResult', this.pagination);
        this.$emit('returnQueryResult', this.query);

        setTimeout(function () {
          let rows = _this.$refs.executivesSearchGrid.invoke("getData");
          let cssArr = ['green-50', 'white'];
          let prevRowMemberNo = null;
          let rowCss = cssArr[0];
          rows.forEach((obj)=>{
//console.log(prevRowMemberNo);            
            if(prevRowMemberNo != obj.memberNo){
              prevRowMemberNo = obj.memberNo;
              rowCss = rowCss == cssArr[0]? cssArr[1] : cssArr[0];
            }
            _this.$refs.executivesSearchGrid.invoke("addRowClassName",obj.rowKey, rowCss);
          });
        },100)
        this.$refs.executivesSearchGrid.invoke("refreshLayout");
        
      }else{
        kuaaFnc.showSwal("임원단 관리", res.resultMessage);
      }
    },

    onDbClickExecutive(e) {
      //if((e.columnName === "levelCdNm" || e.columnName === "reign") && e.instance.getRow(e.rowKey) != null) {
      if(e.columnName === "levelCdNm"  && e.instance.getRow(e.rowKey) != null) {
        this.$emit('setExcutiveData', e.instance.getRow(e.rowKey));
      }else if(e.columnName === "memberNo" && e.instance.getRow(e.rowKey) != null) {
        this.$emit('setExcutiveData', e.instance.getRow(e.rowKey));
        window.open('/Friendship/UpdateMember/' + e.instance.getRow(e.rowKey).memberNo, 'FriendshipUpdateMember');
      }
    },
    customFormatter(date) {
      let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
      return res;
    },
    customFormatter2(date) {
      let res = date && date != '' ? moment(date).format("YYYYMM") : '';
      return res;
    }

  }
};
</script>

<style lang="css" scoped>

</style>